import { getCirugia, postCirugia } from "./ApiHIS"

export const postPrincipalRecordAnestesia=(body)=>{
    return postCirugia('cirugias/record/anestesico',body)
}